/**
 * The support domains the corpus can be authored against.
 *
 * Deliberately its own module with NO import of `corpus.generated`: the
 * generator validates each doc's `meta.domain` against this list, and it must
 * be able to do that BEFORE (and while) it writes the generated file. Importing
 * the barrel would make the generator depend on its own output.
 */
export const SUPPORT_DOMAINS = ['methodology', 'dashboard_usage'] as const;

export type SupportDomain = (typeof SUPPORT_DOMAINS)[number];

export function isSupportDomain(value: string): value is SupportDomain {
  return (SUPPORT_DOMAINS as readonly string[]).includes(value);
}
